/**
 * Teams Migration API Schemas
 */

import { z } from "zod";

export const TeamsMigrationRecordSchema = z.object({
  id: z.string(),
  connectionId: z.string(),
  botDisplayName: z.string(),
  currentWebhookUrl: z.string(),
  expectedWebhookUrl: z.string(),
  webhookStatus: z.enum(["synced", "not_synced"]),
  deploymentStatus: z.enum(["active", "inactive"]),
  /**
   * "nexus_provisioned" = bot was created via Nexus Teams OAuth flow (has subscriptionId/resourceGroupName).
   * Auto-migration via Azure Management API is available.
   *
   * "legacy" = bot was manually created in Azure by the customer before Nexus provisioning.
   * Missing subscriptionId/resourceGroupName — Azure API cannot be called.
   * Requires manual endpoint update in Azure Portal.
   */
  botType: z.enum(["nexus_provisioned", "legacy"]),
  validated: z.boolean(),
  migratedAt: z.string().datetime().nullable()
});

export const TeamsMigrationStatusResponseSchema = z.object({
  total: z.number(),
  synced: z.number(),
  notSynced: z.number(),
  validated: z.number(),
  notValidated: z.number(),
  bots: z.array(TeamsMigrationRecordSchema)
});

export const MigrateTeamsWebhookBodySchema = z.object({
  connectionId: z.string().uuid()
});

export const MigrateTeamsWebhookResponseSchema = z.object({
  success: z.boolean(),
  webhookUrl: z.string().optional(),
  error: z.string().optional()
});
